import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

export const BLANK = 'blank';

interface GeneralTablesCellsTdLinkBaseSignature {
  Args: {
    cellData: {
      formattedValue: string;
      iconAfter?: IconName | 'blank';
      iconBefore?: IconName;
    };
  };
}

export default class GeneralTablesCellsTdLinkBase extends Component<GeneralTablesCellsTdLinkBaseSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasBlankIconAfter() {
    return this.args.cellData.iconAfter === BLANK;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconAfter() {
    if (this.hasBlankIconAfter) {
      return null;
    }

    return this.args.cellData.iconAfter as IconName;
  }

  <template>
    <div class="inline-flex items-center gap-100">
      {{#if @cellData.iconBefore}}
        <PrismIcon
          @color="inherit"
          @name={{@cellData.iconBefore}}
          @size="small"
        />
      {{/if}}
      <p class="truncate tabular-nums {{if this.hasBlankIconAfter 'mr-500'}}">
        {{@cellData.formattedValue}}
      </p>
      {{#if this.iconAfter}}
        <PrismIcon @color="inherit" @name={{this.iconAfter}} @size="small" />
      {{/if}}
    </div>
  </template>
}
